define(["require", "exports", "knockout", "./TagModel"], function (require, exports, ko, TagModel) {
    "use strict";
    var CustomerContactsModel = /** @class */ (function () {
        function CustomerContactsModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.Title = ko.observable();
            this.WorkPhone = ko.observable();
            this.Email = ko.observable();
            this.Website = ko.observable();
            this.Mobile = ko.observable();
            this.Summary = ko.observable();
            this.TagIds = ko.observable();
            this.Tags = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerContactsModel.Mapping, self);
            }
        }
        CustomerContactsModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerContactsModel(options.data);
            },
            Tags: {
                create: function (options) {
                    return new TagModel(options.data);
                }
            }
        };
        return CustomerContactsModel;
    }());
    return CustomerContactsModel;
});
//# sourceMappingURL=CustomerContactsModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerContactsModel.js
// module id = 160
// module chunks = 2